import React from 'react';
import Header from './Header';
import Footer from './Footer';
import '../App.css';

/**
 * Public marketing pages: same chrome as the landing page (header + scrollable body + footer).
 */
function MarketingPageShell({ children, mainClassName = '' }) {
  return (
    <div className="page-flow-wrap">
      <Header />
      <div className={`landing-container marketing-subpage ${mainClassName}`.trim()}>{children}</div>
      <Footer />
    </div>
  );
}

export default MarketingPageShell;
